var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGifts = function SvgGifts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 12,
    fill: "#FFF6E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_53159)",
    filter: "url(#filter0_d_468_53159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4348 15.6751H31.6878C31.9182 15.3105 32.0703 14.9011 32.1137 14.4682C32.2522 13.0845 31.5235 11.8442 30.283 11.2943C29.1427 10.7889 27.8613 10.9955 26.9385 11.8324L24.7326 13.8316C24.303 13.3618 23.6854 13.0665 23 13.0665C22.3134 13.0665 21.6948 13.3627 21.2651 13.834L19.0564 11.8322C18.1321 10.9953 16.8512 10.7895 15.7115 11.2946C14.4712 11.8446 13.7424 13.0853 13.8814 14.4689C13.9248 14.9015 14.0768 15.3106 14.3072 15.6751H12.5652C11.7007 15.6751 11 16.3759 11 17.2403V19.5882C11 20.0204 11.3504 20.3708 11.7826 20.3708H34.2174C34.6496 20.3708 35 20.0204 35 19.5882V17.2403C35 16.3759 34.2993 15.6751 33.4348 15.6751ZM20.6522 15.4143V15.6751H16.9705C15.9977 15.6751 15.2322 14.7683 15.4751 13.7555C15.5821 13.3095 15.9041 12.9293 16.3205 12.7368C16.8922 12.4725 17.5256 12.5574 18.0058 12.9921L20.6528 15.3912C20.6527 15.399 20.6522 15.4065 20.6522 15.4143ZM30.5607 14.2604C30.5023 15.0738 29.7676 15.6752 28.9521 15.6752H25.3478V15.4144C25.3478 15.4051 25.3473 15.396 25.3472 15.3868C25.9468 14.8432 27.2476 13.6642 27.9531 13.0247C28.3541 12.6613 28.9152 12.4916 29.4338 12.6463C30.178 12.8683 30.6151 13.5012 30.5607 14.2604Z",
    fill: "#FFA324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5652 21.9355V33.4138C12.5652 34.2783 13.2659 34.979 14.1304 34.979H21.4347V21.9355H12.5652Z",
    fill: "#FFA324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5652 21.9355V34.979H31.8695C32.734 34.979 33.4347 34.2783 33.4347 33.4138V21.9355H24.5652Z",
    fill: "#FFA324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_53159",
    x: 5,
    y: 9,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.833333 0 0 0 0 0.407222 0 0 0 0 0.0138889 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_53159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_468_53159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_53159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGifts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gifts.0bfea388f211f61e2318c067c6b776fc.svg";